export default "__VITE_ASSET__BYpe98rc__"